var yy_request = require('../js/yunyin_request')
var po = require('../js/public_object.js')

module.exports = {
  data: function() {
    return {
      searchKey: "",
      latestKey: "",
      booksPerPage: 10,
      bookList: [],
      displayedPage: 1,
      moreData: false,
      tips:"那些你找了很久的绝版图书，稀有课件，复习资料也许就静静躺在在某个打印店里呢",
      showDetailModal: false,
      modalWidth: 600,
      modalTitle: "图书详情",
      bookInfo: {name:"",detail:"",printer:"",price:"",time:""},
    }
  },

  complied: function() {

  },

  methods: {
    onSearchBook: function() {
      this.displayedPage = 1
      this.latestKey = this.searchKey
      loadData(this, this.searchKey)
    },

    loadMore: function() {
      this.displayedPage += 1
      loadData(this, this.latestKey)
    },

    showBookDetail: function(book) {
      var vuemodel = this
      yy_request.rest_api({
        method: 'get',
        api: 'books/' + book.id,
        opSuccess: function(info) {
          vuemodel.bookInfo = info
        },
      })
      this.showDetailModal = true
    },

    onBuy: function() {
      this.showDetailModal = false
    }
  },

  components: {
    'modal': require('../components/modal.vue'),
  }
}

function loadData(vuemodel,keywords) {
  var ajax_data = {
    key: keywords,
    page: vuemodel.displayedPage
  }

  yy_request.rest_api({
    method: 'get',
    api: 'books/',
    data: ajax_data,
    opSuccess: function(info) {
      if(info.length>0) {
        vuemodel.tips = ""
        var bookdata = info
        if(bookdata.length==vuemodel.booksPerPage) {
          vuemodel.moreData = true
        } else {
          vuemodel.moreData = false
        }

        if(vuemodel.displayedPage==1) {
          vuemodel.bookList = bookdata
        } else {
          vuemodel.bookList = vuemodel.bookList.concat(bookdata)       
        }        
      } else {
        vuemodel.bookList = []
        vuemodel.tips = "没有找到结果，不如换个关键词试试"
      }
    },
  })
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/book-view.vue
// module id = 150
// module chunks = 0